import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import ExploreMoreTierUpsell from './ExploreMoreTierUpsell';
import WantMoreSubscribersTierUpsell from './WantMoreSubscribersTierUpsell';

export interface Props {
  className?: string;
  deviation: PapiDeviation;
}

export const TierUpsell: React.FC<Props> = ({ className, deviation }) => {
  const { tier, isOwner, isUserSubscribed } = useSubscriptionTier(deviation);
  if (!tier || isUserSubscribed) {
    return null;
  }

  if (isOwner) {
    return <WantMoreSubscribersTierUpsell className={className} />;
  }

  return <ExploreMoreTierUpsell className={className} authorName={deviation.author?.username} />;
};
TierUpsell.displayName = 'TierUpsell';

export default TierUpsell;
